import { SagaIterator } from "redux-saga";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { select } from "redux-saga/effects";

import { ReportType } from "constants/reports/report-type";
import { ApiManager } from "services/api";
import { serializeFilters } from "services/api/report/report-serializer";
// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6133): 'selectLoggedInAgent' is declared but its value is... Remove this comment to see the full error message
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { selectLoggedInAgent } from "store/entities/agents";
import { selectFeatureTogglePerformanceReport } from "store/entities/license";
import { Plan, selectCurrentSubscriptionPlan } from "store/entities/subscriptions";
import { IActionWithPayload } from "store/helper";

import { IFetchReportPayload } from "../interfaces";

import { makeFetchingSaga } from "./helpers";

export function* fetchTicketRating(action: IActionWithPayload<string, IFetchReportPayload>): SagaIterator {
  const { payload } = action;
  const { filters, distribution } = payload;
  // @ts-expect-error TS(2345): Argument of type 'ReportDistribution | undefined' ... Remove this comment to see the full error message
  const serializedFilters = serializeFilters(filters, distribution, []);
  const isTeam = yield select(state => selectCurrentSubscriptionPlan(state) === Plan.Team);
  const hasPerformanceReport = yield select(selectFeatureTogglePerformanceReport);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const requests: any[] = [
    {
      name: "ticketsRatingResponse",
      interface: ApiManager.reportApi.fetchTicketsSatisfaction,
    },
  ];

  if (!serializedFilters.agent) {
    requests.push({
      name: "ticketsRankingResponse",
      interface: ApiManager.reportApi.fetchAgentRating,
      disableComparison: true,
    });
  }

  if (hasPerformanceReport) {
    requests.push({
      name: "ticketsRatingResponsePerTeam",
      interface: ApiManager.reportApi.fetchTicketsSatisfactionPerTeam,
    });
    if (!isTeam) {
      requests.push({
        name: "ticketsRatingResponsePerAgent",
        interface: ApiManager.reportApi.fetchTicketsSatisfactionPerAgent,
      });
    }
  }

  // @ts-expect-error TS(2345): Argument of type 'any[]' is not assignable to para... Remove this comment to see the full error message
  yield makeFetchingSaga(ReportType.TicketRatings, action, requests);
}
